import axios from "axios";
import { API_HOST } from "@/core/variables";
import { BulkTestCreate, BulkTestStatusType } from "@/model";

class BulkTestRepository {
    create = async (agentId: number, form: BulkTestCreate) => {
        const formData: any = new FormData();
        formData.append("title", form.title);
        formData.append("file", form.file);

        return await axios
            .post(`${API_HOST}/v1/agents/${agentId}/testing`, formData, {
                headers: {
                    contentType: false,
                    processData: false,
                    cache: false,
                    enctype: "multipart/form-data"
                }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    find = async (
        agentId: number,
        page: number,
        size: number,
        sortKey: "created_at" | "success_rate",
        sort: "asc" | "desc",
        status?: BulkTestStatusType,
        keyword?: string
    ) => {
        return await axios
            .get(`${API_HOST}/v1/agents/${agentId}/testing`, {
                params: {
                    agent_id: agentId,
                    page: page,
                    size: size,
                    sort_key: sortKey,
                    sort: sort,
                    status: status,
                    keyword: keyword
                }
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    read = async (agentId: number, testId: string = "last") => {
        return await axios
            .get(`${API_HOST}/v1/agents/${agentId}/testing/${testId}/result`)
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    deleteMany = async (agentId: number, ids?: string[], keyword?: string) => {
        const params = new URLSearchParams();
        ids?.forEach((id) => {
            params.append("ids", id);
        });
        if (keyword)
            params.append("keyword", keyword);

        return axios
            .delete(`${API_HOST}/v1/agents/${agentId}/testing`, {
                params: params
            })
            .then((response) => Promise.resolve(response))
            .catch((error) => Promise.reject(error));
    };

    exportResult = (agentId: number, testId: string = "last") => {
        window.open(`${API_HOST}/v1/agents/${agentId}/testing/${testId}/export/result`);
    };

    exportCase = (agentId: number, testId: string = "last") => {
        window.open(`${API_HOST}/v1/agents/${agentId}/testing/${testId}/export/case`);
    };
}

const bulkTestRepository = new BulkTestRepository();

export default bulkTestRepository;
